const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const getFieldErrors = (field: string, newValue: string) => {
  if (newValue.length === 0) {
    return "This field is required";
  }

  switch (field) {
    case "email":
      return !EMAIL_REGEX.test(newValue) ? "Please enter a valid email address" : null;
    case "password":
      return newValue.length < 8 ? "Password must be at least 8 characters long" : null;
    default:
      return null;
  }
}

export const updateFieldValidations = (field: string, target: HTMLInputElement) => {
  const error = getFieldErrors(field, target.value);
  const parentGroup = target.closest(".form-group");
  const errorElement = parentGroup.querySelector(".error-message");

  if (!parentGroup || !errorElement) {
    return;
  }

  parentGroup.classList.toggle("has-error", !!error);
  errorElement.textContent = error ?? "";

  return !error;
}

export const setCookie = (name: string, value: string, options?: {
  days?: number;
}) => {
  const { days = 1 } = options || {};

  const expires = new Date();
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
  
  let cookieString = `${name}=${value}; path=/; expires=${expires.toUTCString()}; domain=.archdaily.com`;
  document.cookie = cookieString;
}

export const getCookie = (name: string) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

export const removeCookie = (name: string) => {
  console.log("removing cookie", name);
  document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=.archdaily.com`;
}
